import React from 'react'
import { LoadingSpinnerIcon } from '@/atoms/Icons/LoadingSpinnerIcon'
import { useHlsPlayerUI } from './HlsPlayerUIContext'

/**
 * Buffering/loading spinner overlay.
 * Shown when the video is waiting for data (e.g., initial load, seek, network stall).
 * Centered over the video area with a semi-transparent backdrop.
 */
export const HlsBufferingOverlay: React.FC = () => {
  const { waiting } = useHlsPlayerUI()

  if (!waiting) return null

  return (
    <div className="pointer-events-none absolute inset-0 flex items-center justify-center">
      <LoadingSpinnerIcon size={48} color="white" />
    </div>
  )
}
